import PropTypes from 'prop-types';
import React from 'react';
import Slideshow from '../Shared/Slideshow/Slideshow';
import CuratedButton from './CuratedButton';
import { CuratedButtonGroupStyles } from './CuratedButtonGroup.styled';

const CuratedButtonGroup = ({ heading, buttonInfo }) => {
  const getButtons = () => {
    return buttonInfo.slice(0, 4).map((button, index) => {
      return (
        <CuratedButton
          key={`curated-button-${index}`}
          info={button}
          className={
            buttonInfo.length <= 4
              ? buttonCountClassNames[buttonInfo.length]
              : buttonCountClassNames[4]
          }
        />
      );
    });
  };

  const buttonCountClassNames = ['', 'one', 'two', 'three', 'four'];

  return (
    <CuratedButtonGroupStyles className="curated-buttons-container">
      <div className="curated-button-group constrained-width">
        {heading && <h4 className="curated-button-group-heading">{heading}</h4>}
        <div
          className={`curated-buttons ${buttonInfo.length >= 4 && 'full-row'}`}
        >
          <Slideshow
            transitionTime={200}
            showThumbs={false}
            imageArray={getButtons()}
            isDesktop={false}
          />
          {getButtons()}
        </div>
      </div>
    </CuratedButtonGroupStyles>
  );
};

CuratedButtonGroup.propTypes = {
  buttonInfo: PropTypes.array,
  heading: PropTypes.any,
};

export default CuratedButtonGroup;
